import { pxToRem, remToPx } from '../utils';

export const typography = {
  fontFamily: {
    sans: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    mono: 'Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
  },

  // Heading styles
  heading1: {
    regular: {
      fontSize: '2rem', // 32px
      lineHeight: '3rem', // 48px
      fontWeight: 400,
    },
    bold: {
      fontSize: '2rem', // 32px
      lineHeight: '3rem', // 48px
      fontWeight: 700,
    },
  },
  heading2: {
    regular: {
      fontSize: '1.5rem', // 24px
      lineHeight: '2.5rem', // 40px
      fontWeight: 400,
    },
    bold: {
      fontSize: '1.5rem', // 24px
      lineHeight: '2.5rem', // 40px
      fontWeight: 700,
    },
  },
  heading3: {
    regular: {
      fontSize: '1.125rem', // 18px
      lineHeight: '2rem', // 32px
      fontWeight: 400,
    },
    bold: {
      fontSize: '1.125rem', // 18px
      lineHeight: '2rem', // 32px
      fontWeight: 700,
    },
  },

  // Body styles
  body1: {
    regular: {
      fontSize: '1rem', // 16px
      lineHeight: '1.5rem', // 24px
      fontWeight: 400,
    },
    bold: {
      fontSize: '1rem', // 16px
      lineHeight: '1.5rem', // 24px
      fontWeight: 700,
    },
  },
  body2: {
    regular: {
      fontSize: '0.875rem', // 14px
      lineHeight: '1.25rem', // 20px
      fontWeight: 400,
    },
    bold: {
      fontSize: '0.875rem', // 14px
      lineHeight: '1.25rem', // 20px
      fontWeight: 700,
    },
  },
  body3: {
    regular: {
      fontSize: '0.75rem', // 12px
      lineHeight: '1rem', // 16px
      fontWeight: 400,
    },
    bold: {
      fontSize: '0.75rem', // 12px
      lineHeight: '1rem', // 16px
      fontWeight: 700,
    },
  },

  // General styles
  fontSize: {
    xs: '0.75rem', // 12px
    sm: '0.875rem', // 14px
    base: '1rem', // 16px
    lg: '1.125rem', // 18px
    xl: '1.25rem', // 20px
    '2xl': '1.5rem', // 24px
    '3xl': '1.875rem', // 30px
    '4xl': '2.25rem', // 36px
    '5xl': '3rem', // 48px
    pxToRem,
    remToPx,
  },
  fontWeight: {
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  lineHeight: {
    none: 1,
    tight: 1.25,
    snug: 1.375,
    normal: 1.5,
    relaxed: 1.625,
    loose: 2,
  },
  pxToRem,
  remToPx,
} as const;

export type Typography = typeof typography;
